"use client";

import { FilterDrawerView } from "@core/components/controlled-table/table-filter";
import cn from "@core/utils/class-names";
// import { getDateRangeStateValues } from "@core/utils/get-formatted-date";
import { type Table as ReactTableType } from "@tanstack/react-table";
import { useState } from "react";
import {
  PiFunnel,
  PiMagnifyingGlassBold,
  // PiTrashDuotone,
} from "react-icons/pi";
import { useMedia } from "react-use";
import { Button, Flex, Input } from "rizzui";
import ToggleColumns from "@core/components/table-utils/toggle-columns";

interface TableToolbarProps<T extends Record<string, any>> {
  table: ReactTableType<T>;
}

export default function Filters<TData extends Record<string, any>>({
  table,
}: TableToolbarProps<TData>) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const isLarge = useMedia("(min-width: 1920px)", false);

  return (
    <Flex align="center" justify="between" className="mb-4 gap-0">
      <Flex align="center" className="w-auto flex-wrap">
        <Input
          type="search"
          placeholder="Search by campaign ID..."
          value={
            (table.getColumn("campaignId")?.getFilterValue() as string) ?? ""
          }
          onClear={() => table.getColumn("campaignId")?.setFilterValue("")}
          onChange={(e) =>
            table.getColumn("campaignId")?.setFilterValue(e.target.value)
          }
          inputClassName="h-9"
          clearable={true}
          prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
        />
        {isLarge && showFilters && <FilterElements table={table} />}
      </Flex>
      <Flex align="center" className="w-auto">
        <Button
          {...(!isLarge
            ? {
                onClick: () => {
                  setOpenDrawer(() => !openDrawer);
                },
              }
            : { onClick: () => setShowFilters(() => !showFilters) })}
          variant={"outline"}
          className={cn(
            "h-[34px] pe-3 ps-2.5",
            isLarge && showFilters && "border-dashed border-gray-700"
          )}
        >
          <PiFunnel className="me-1.5 size-[18px]" strokeWidth={1.7} />
          {isLarge && showFilters ? "Hide" : "Filters"}
        </Button>

        {!isLarge && (
          <FilterDrawerView
            drawerTitle="Table Filters"
            isOpen={openDrawer}
            setOpenDrawer={setOpenDrawer}
          >
            <div className="grid grid-cols-1 gap-6">
              <FilterElements table={table} />
            </div>
          </FilterDrawerView>
        )}

        <ToggleColumns table={table} />
      </Flex>
    </Flex>
  );
}

function FilterElements<T extends Record<string, any>>({
  table,
}: TableToolbarProps<T>) {
  return (
    <>
      {/* KYC Verified Filter */}

      {/* Status Filter */}
      <select
        value={(table.getColumn("status")?.getFilterValue() as string) ?? ""}
        onChange={(e) =>
          table.getColumn("status")?.setFilterValue(e.target.value)
        }
      >
        <option value="">All Campaign Status</option>
        <option value="ongoing">Ongoing</option>
        <option value="completed">Completed</option>
        <option value="pending">Pending</option>
        <option value="flagged">Flagged</option>
      </select>
    </>
  );
}
